import { cn } from "@/lib/utils";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "react-router-dom";

interface ActionCardProps {
  title: string;
  description?: string;
  icon: React.ComponentType<{ className?: string }>;
  href?: string;
  onClick?: () => void;
  bgClass: string; // e.g., "bg-blue-100 dark:bg-blue-900/30"
  hoverBgClass: string; // e.g., "hover:bg-blue-200 dark:hover:bg-blue-900/50"
  iconColorClass: string; // e.g., "text-blue-700 dark:text-blue-300"
  textClass?: string; // e.g., "text-foreground"
  className?: string;
  compact?: boolean; // tighter padding for grid contexts
}

export function ActionCard({
  title,
  description,
  icon: Icon,
  href,
  onClick,
  bgClass,
  hoverBgClass,
  iconColorClass,
  textClass = "text-foreground",
  className,
  compact = false,
}: ActionCardProps) {
  const content = (
    <Card
      className={cn(
        "transition-colors",
        bgClass,
        hoverBgClass,
        "border-0 shadow-card hover:shadow-elevated",
        className
      )}
      onClick={onClick}
    >
      <CardContent
        className={cn(
          compact ? "p-4 sm:p-6" : "p-8",
          "flex flex-col items-center justify-center text-center h-full"
        )}
      >
        <div className={cn("w-12 h-12 sm:w-14 sm:h-14 rounded-full flex items-center justify-center mb-3 sm:mb-4 bg-white/70 dark:bg-white/10")}> 
          <Icon className={cn("h-6 w-6 sm:h-7 sm:w-7", iconColorClass)} />
        </div>
        <h3 className={cn("font-medium mb-1 text-sm sm:text-base leading-tight line-clamp-2", textClass)}>
          {title}
        </h3>
        {description && (
          <p className={cn("text-xs sm:text-sm leading-tight line-clamp-2", textClass === "text-foreground" ? "text-muted-foreground" : textClass + "/80")}>
            {description}
          </p>
        )}
      </CardContent>
    </Card>
  );

  if (href) {
    return <Link to={href}>{content}</Link>;
  }

  return content;
}

export default ActionCard;


